import { InjectionKey, Ref } from "@vue/composition-api";

export const IdKey: InjectionKey<Ref<string>> = Symbol();
export const EditableKey: InjectionKey<Ref<boolean>> = Symbol();
export const FullScreenKey: InjectionKey<Ref<boolean>> = Symbol();
export const ConfirmDeleteFunctionKey: InjectionKey<
  (name: string, nameToConfirm: string) => Promise<boolean>
> = Symbol();
